import { DateTime } from "luxon"

//PrimeReact
import { Tooltip } from "primereact/tooltip"

//Styles
import myStyles from "../../../../../../styles/assessments/ManagementFormulaBuilder.module.css"

import RenderFormulaConnector from "./RenderFormulaConnector"
import RenderFormulaClose from "./RenderFormulaClose"
import elementTypes from "../../Elements/elementTypes"

export default function RenderFormulaOption({
  formulaOrder,
  dndRef,
  dndStyle,
  dndAttributes,
  dndListeners,
  hideConnector,
  overConnectorId,
}) {
  const titleIsTooLong = formulaOrder.option.title?.length > 100
  const tooltipTarget = `tt-questionTitle-${formulaOrder.option.id}`

  let typeProfile = elementTypes.findTypeProfile(formulaOrder.option.type)

  if (formulaOrder) {
    return (
      <div
        className={`${myStyles.formulaRenderLayout} ${
          hideConnector ? myStyles.formulaRenderLayoutNoConnect : ""
        }`}
        ref={dndRef}
        style={dndStyle}
        {...dndAttributes}
        {...dndListeners}
      >
        {titleIsTooLong && (
          <Tooltip
            target={`.${tooltipTarget}`}
            className={myStyles.functionToolTip}
          />
        )}
        <div
          className={`${myStyles.formulaRenderLayoutBody} ${
            myStyles.formulaRenderBodyQuestion
          } ${titleIsTooLong ? tooltipTarget : ""}`}
          data-pr-tooltip={formulaOrder.option.title}
          data-pr-position="bottom"
        >
          <div className={myStyles.formulaRenderBodyQuestionIcon}>
            <span className="material-icons">{typeProfile?.icon}</span>
          </div>
          <div className={myStyles.formulaRenderBodyQuestionBody}>
            {titleIsTooLong
              ? formulaOrder.option.title.substring(0, 100) + "..."
              : formulaOrder.option.title}
          </div>
        </div>
        {!hideConnector ? (
          <div className={myStyles.formulaRenderLayoutConnector}>
            <RenderFormulaConnector
              connector={formulaOrder.option.connectingOperator}
              formulaId={formulaOrder?.id}
              overConnectorId={overConnectorId}
            />
          </div>
        ) : null}
        <RenderFormulaClose formulaOrderid={formulaOrder.id} />
      </div>
    )
  } else {
    return <>Unknown formula object</>
  }
}
